import Vue from "vue";
import Vuex from "vuex";

Vue.use(Vuex);
var store = new Vuex.Store({
  // 存储状态。也就是变量
  state: {
    // 这里放全局参数
    level2msg: "" //
  },
  // 提交状态修改。也就是set.外部调用方式：store.commit('SET_AGE', 18)
  mutations: {
    // 这里是set方法
    setWebsocketmsg(state, msg) {
      state.level2msg = msg;
    }
  },
  getters: {
    // get方法
  },
  // 和mutations类似。不过actions支持异步操作,外部调用方式：store.dispatch('nameAsyn')。
  actions: {},
  strict: true
});

export default store;
